import React from 'react';
import ShipmentFilterRow from './ShipmentFilterRow';
import styles from './systemEventTimelineStyles.scss';

const ShipmentFilterSection = ({
  title,
  filters,
  isExpanded,
  onToggleExpanded,
  detailState,
  setDetailState,
  onSectionToggle,
  emptyText,
}) => {
  const count = filters.length;

  const toggleFilterDetails = filterId => {
    setDetailState(prev => ({ ...prev, [filterId]: !prev[filterId] }));
    if (onSectionToggle) onSectionToggle();
  };

  const toggleAllDetails = () => {
    const shouldExpandAll = filters.some(filter => !detailState[filter.id]);
    const nextState = filters.reduce((acc, filter) => {
      acc[filter.id] = shouldExpandAll;
      return acc;
    }, {});

    setDetailState(nextState);
    if (onSectionToggle) onSectionToggle();
  };

  const areAllDetailsExpanded = filters.length > 0
    && filters.every(filter => Boolean(detailState[filter.id]));

  const renderFilterRows = () => {
    if (!filters.length) {
      return <div className={styles.dropdownEmpty}>{emptyText}</div>;
    }

    return (
      <div className={styles.dropdownFilterList}>
        {filters.map(filter => (
          <ShipmentFilterRow
            key={filter.id}
            filter={filter}
            isExpanded={Boolean(detailState[filter.id])}
            onToggle={() => toggleFilterDetails(filter.id)}
            isMatchedSection={title === 'Matched Filters'}
          />
        ))}
      </div>
    );
  };

  return (
    <div className={styles.dropdownSection}>
      <button
        type="button"
        className={styles.dropdownToggle}
        onClick={onToggleExpanded}
        aria-expanded={isExpanded}
      >
        <span>{title} ({count})</span>
        <span className={`${styles.chevron} ${isExpanded ? styles.chevronDown : styles.chevronRight}`} />
      </button>

      {isExpanded && filters.length > 0 && (
        <button
          type="button"
          className={styles.dropdownDetailToggle}
          onClick={toggleAllDetails}
        >
          {areAllDetailsExpanded ? 'Hide all activities' : 'Show all activities'}
        </button>
      )}

      {isExpanded && renderFilterRows()}
    </div>
  );
};

export default ShipmentFilterSection;
